import React from "react";
import styled, { css } from "styled-components";
import NotificationsIcon from "@material-ui/icons/Notifications";
import {
  white,
  black200,
  blue300,
  black600,
  black400,
  curiousBlue300,
  cinnabar300,
  blue500,
  black500,
} from "../../../theme/colors";
import { ToolTip } from "../../../components/ToolTip";
import { UserIcon } from "../../../components/UserIcon";
import { DropDown } from "../../../components/DropDown";
import {
  baseCaption,
  regularHeading,
  miniCaption,
} from "../../../theme/typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { bold } from "../../../theme/typeface";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import EditIcon from "@material-ui/icons/Edit";
import { getNotificationOption } from "./getNotificationOption";
import dateUtils from "../../../helpers/utils/dateUtils";
import wordWrap from "../../../helpers/utils/wordWrap";
import isDiffer from "../../../helpers/utils/isDiffer";
// import { ToolTip } from "../../../components/ToolTip";

const ProjectCardStyle = styled.div`
  width: 100%;
  min-height: 260px;
  height: auto;
  background: ${white};
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px -2px rgba(91, 127, 220, 0.08), 0 2px 8px -1px rgba(91, 127, 220, 0.06);
  border: 1px solid #E2E8F0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: 0 20px 25px -5px rgba(91, 127, 220, 0.15), 0 10px 10px -5px rgba(91, 127, 220, 0.1);
    transform: translateY(-4px);
    border-color: ${blue300}55;
    z-index: 3;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, ${blue300}, ${curiousBlue300});
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }

  & > :nth-child(1) {
    img {
      height: 38px;
      max-width: 120px;
      object-fit: contain;
    }
  }
`;

const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: ${(props) => props.alignItem || "center"};
  padding-bottom: ${(props) => props.paddingBottom || "0"};
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const TitleText = styled.p`
  ${regularHeading.mini}
  font-weight: ${bold};
  margin: 0;
  color: ${blue500};
  line-height: 1.3;
`;

const CardBody = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 16px;
`;

const CardHeaderSection = styled.div`
  min-height: 80px;
  border-bottom: 1px dashed ${black200};
  padding-bottom: 14px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
`;

const ProjectIdText = styled.span`
  color: ${black400};
  font-size: 13px;
  font-weight: 500;
`;

const ProjectTypeBadge = styled.span`
  background: #EBF8FF;
  color: #2B6CB0;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
`;

const CardFooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
`;

const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DateRangeText = styled.span`
  ${miniCaption.regular}
  color: ${black600};
  display: flex;
  align-items: center;
`;

const OutletsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F8FAFC;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #EDF2F7;
`;

const OutletsLabel = styled.span`
  color: ${black500};
  font-size: 12px;
  font-weight: 500;
`;

const OutletsValue = styled.span`
  color: ${blue500};
  font-size: 14px;
  font-weight: 700;
`;

export const AnchorText = styled.a`
  color: ${curiousBlue300};
  cursor: pointer;
  ${baseCaption}
`;

export const ProjectCard = ({
  onNotificationClickAction,
  onClickItem,
  onEditAction,
  setDeckFile,
  deckPath,
  slug,
  logo,
  notificationList = [],
  type,
  outlets_count,
  name,
  notificationCount,
  createdDate = new Date(),
  endDate = new Date(),
  pro,
  showFilterList = false,
  projectId,
  cardBackgroundColor,
  isVisibleInActiveAction = false,
  isVisibleOtherActionMenu = true
}) => {
  const createdDateText = createdDate ? dateUtils().getFullDate(createdDate) : '';
  const endDateText = endDate ? dateUtils().getFullDate(endDate) : '';

  // Increased length for wrap to fit the wider grid layouts
  const projectName = wordWrap(name, 24);
  let optionList = [
    { label: "Edit", icon: <EditIcon />, key: "" },
    { label: "In-Active", icon: <EditIcon />, key: "" }
  ];
  if (isVisibleInActiveAction === false) {
    optionList = optionList.slice(0, -1);
  }

  return (
    <ProjectCardStyle showFilterList={showFilterList} style={{ borderRadius: 16, backgroundColor: cardBackgroundColor ? cardBackgroundColor : "white" }}>
      <CardRow>
        <img src={logo} />
        <div>
          <DropDown
            heading={`Notification (${notificationCount})`}
            menuAlign="right"
            menuWidth="250px"
            listBorderLine="dashed"
            listPadding="12px 0"
            menuStartGap="2px"
            options={getNotificationOption(notificationList, onNotificationClickAction)}
          >
            {notificationCount ? (
              <UserIcon
                letter={notificationCount + ''}
                parentMargin="0 10px 0 0"
                letterIconStyle={{
                  width: "22px",
                  height: "22px",
                  ...baseCaption,
                  margin: "0",
                  verticalAlign: "sub",
                  background: cinnabar300,
                }}
                dropDownIconStyle={{ width: "4px", top: "18%" }}
              />
            ) : null}
          </DropDown>
          {isVisibleOtherActionMenu && (
            <>
              {onEditAction ? (
                <DropDown
                  menuAlign="right"
                  options={optionList}
                  onClickAction={(selectedValue) => {
                    onEditAction(slug, selectedValue.label)
                  }}
                  triggerAction='click'
                >
                  <MoreVertIcon style={{ position: "relative", top: "8px" }} />
                </DropDown>
              ) : null}
            </>
          )}

          {deckPath ? (
            <NotificationsIcon
              onClick={() => {
                setDeckFile(deckPath)
              }}
              style={{ position: "relative", top: "8px", cursor: 'pointer' }}
            />
          ) : null}
        </div>
      </CardRow>
      <CardBody onClick={(e) => {
        e && e.preventDefault();
        onClickItem(pro)
      }}>
        <CardHeaderSection>
          {isDiffer(projectName, name) ? (
            <ToolTip
              icon={<TitleText>{projectName}</TitleText>}
              content={name}
              align={"bottom center"}
              toolDisplay=""
              styleProps={{ minHeight: 0, paddingBottom: 10 }}
            />
          ) : (
            <TitleText style={{ paddingBottom: 10 }}>{projectName}</TitleText>
          )}
          <CardRow>
            <ProjectIdText>ID: {projectId}</ProjectIdText>
            <ProjectTypeBadge>{type}</ProjectTypeBadge>
          </CardRow>
        </CardHeaderSection>

        <CardFooterSection>
          {createdDateText ? (
            <FooterRow>
              <CalendarTodayIcon style={{ color: blue300, fontSize: "14px" }} />
              <DateRangeText>
                {endDateText ? `${createdDateText} to ${endDateText}` : `${createdDateText}`}
              </DateRangeText>
            </FooterRow>
          ) : null}

          <OutletsContainer>
            <OutletsLabel>No. of Outlets</OutletsLabel>
            <OutletsValue>{outlets_count || 0}</OutletsValue>
          </OutletsContainer>
        </CardFooterSection>
      </CardBody>
    </ProjectCardStyle>
  );
};
